import { configureStore } from "@reduxjs/toolkit"
import { compose } from "redux"
import { combineEpics, createEpicMiddleware } from "redux-observable"
import thunk from "redux-thunk"
import { contactEpics } from "./contact/epics"
import { inventoryEpics } from "./inventory"
import { invoiceEpics } from "./invoice/epics"
import { listingEpics } from "./listing"
import { productEpics } from "./product/epics"
import { projectEpics } from "./project"
import { proposalEpics } from "./proposal/epics"
import rootReducer from "./rootReducer"

declare global {
    interface Window {
        __REDUX_DEVTOOLS_EXTENSION_COMPOSE__?: typeof compose
    }
}

const epicMiddleware = createEpicMiddleware()
export const rootEpics = combineEpics(
    listingEpics,
    contactEpics,
    invoiceEpics,
    productEpics,
    inventoryEpics,
    projectEpics,
    proposalEpics
)

const store = configureStore({
    reducer: rootReducer,
    middleware: [thunk, epicMiddleware],
    devTools: process.env.NODE_ENV !== "production" && typeof window !== "undefined",
})

epicMiddleware.run(rootEpics)

export type RootState = ReturnType<typeof store.getState>

export default store



// WEBPACK FOOTER //
// ./src/state/store.ts